<template lang="pug">
v-flex.no-wrap
  span {{ this.item }}
</template>

<script>
import GetItem from '@/Core/mixins/getItem';

export default {
  mixins: [GetItem],
  props: {
    data: {
      type: Object,
    },
    dataKey: {
      type: String,
    },
  },
};
</script>
